<template>
    <div>
        <hts-form :rules="rules">
            <hts-form-select
                v-model="select"
                label="Select"
                color="primary"
                required
                :items="items"
                creatable
                @create-new="createNew" />
            <hts-divider />
            <hts-form-date
                v-model="year"
                type="year"
                prop="year"
                required
                label="Year" />
        </hts-form>
    </div>
</template>

<script setup lang="ts">
const items = ref([
  {
    label: 'label',
    value: 'value'
  },
  {
    label: 'labe2l',
    value: 'value2'
  },
  {
    label: 'label3',
    value: 'value3'
  }
])
const selectItems = ref([])
const checkbox = ref(['value'])
const toggle = ref(true)
const selectRadio = ref(123)
const selectButton = ref(123)
const visible = ref(false)
const visible2 = ref(false)
const visible3 = ref(false)
const userName = ref('')
const input = ref('test input')
const inputNumber = ref(1234556)
const date = ref('')
const year = ref('')
const month = ref('')
const vehicle = ref('63ff1e19b9e46968a6f826ba')
const vehicleText = ref('Vehicle Text')
const datetime = ref('2023-01-30T07:54:12.699Z')

const daterange = ref(['2023-01-30T07:54:12.699Z', '2023-01-30T07:54:12.699Z'])
const file = ref<File | undefined>(undefined)
const files = ref<File[] | undefined>(undefined)
const select = ref('')

const rules = ref({
  input: 'required',
  file: 'required'
})
const createNew = () => {
  alert('create')
}
</script>
